<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Nazwa'"
      [data]="organization()?.nazwa"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'NIP'"
      [data]="organization()?.nip"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'REGON'"
      [data]="organization()?.regon"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'PESEL'"
      [data]="organization()?.pesel"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Numer lub indeks w rejestrze publicznym'"
      [data]="organization()?.indeks"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Nazwa rejestru'"
      [data]="organization()?.indeksNazwa"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Rodzaj podmiotu'"
      [data]="
        organization()?.rodzajPodmiotu
          | constLabelReader: RODZAJ_PODMIOTU_LABELS
      "
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
</div>
